import styled from 'styled-components';
import { breakPoints, colors, fontWeight } from 'utils/variables';
import hexToRGBA from 'utils/hexToRGBA';

export const StyledWrapper = styled.div`
  position: relative;
  margin: auto;
  width: 100%;
  padding: 5rem 0 0 0;

  @media (min-width: ${breakPoints.tablet}) {
    margin: 7rem auto auto auto;
    width: calc(100% - 14.2rem);
    padding: 7.1rem 7.1rem 5.5rem 7.1rem;
    background-color: ${colors.white};
    box-shadow: 0 0 1rem ${hexToRGBA(colors.black, 0.1)};
  }

  @media (min-width: ${breakPoints.desktop}) {
    margin: auto;
    width: 77.1rem;
  }

  &:before {
    @media (min-width: ${breakPoints.desktop}) {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      box-shadow: 1rem 1rem 0 0 ${colors.butter};
      left: 0;
      top: 0;
      pointer-events: none;
    }
  }
`;

export const StyledTitle = styled.h2`
  padding: 0;
  margin: 0;
  font-weight: ${fontWeight.medium};
  color: ${colors.veryDarkBlue};
  width: 100%;
  text-align: center;
  font-size: 2.4rem;
  line-height: 3.2rem;

  @media (min-width: ${breakPoints.tablet}) {
    font-size: 3.2rem;
    line-height: 4.8rem;
  }
`;

export const StyledForm = styled.form`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 1rem;

  @media (min-width: ${breakPoints.tablet}) {
    padding: 0;
  }

  @media (min-width: ${breakPoints.desktop}) {
    margin: auto;
  }

  button {
    display: block;
    margin: 3rem auto 8rem auto;
    transition: filter 300ms ease;

    @media (min-width: ${breakPoints.tablet}) {
      margin: 3rem auto 0 auto;
    }

    &:disabled {
      filter: grayscale(100);
    }
  }

  .text-input {
    padding: 0;
    margin: 6rem 0 0 0;
    width: 100%;

    @media (min-width: ${breakPoints.desktop}) {
      margin: 4.7rem 0 0 0;
      width: 37rem;
    }
  }

  .agreement {
    width: 100%;
    margin-top: 3.5rem;
  }
`;
